import { accessToken } from "../components/core/auth-service/auth-service";
import {
  FETCH_ORDER_DETAILS_BEGIN, FETCH_ORDER_DETAILS_FAILURE, FETCH_ORDER_DETAILS_SUCCESS,
  FETCH_ORDERS_BEGIN,
  FETCH_ORDERS_FAILURE,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_SYNC,
  UPDATE_ORDER_DETAILS_STATE
} from "./actionTypes";
import getConfig from '../environment';

import {GetOrdersRequest} from "../model/GetOrdersRequest";
import {ErrorResponseWrapper} from "../model/ErrorResponseWrapper";
import {GetOrderDetailsRequest} from "../model/GetOrderDetailsRequest";
import {GetOrderItemDetailsRequest} from "../model/GetOrderItemDetailsRequest";


export const fetchOrdersBegin = request => ({
  type: FETCH_ORDERS_BEGIN,
  payload: request
});

export const fetchOrdersSuccess = (orderResponse) => ({
  type: FETCH_ORDERS_SUCCESS,
  payload: { orderResponse }
});

export const fetchOrdersFailure = errors => ({
  type: FETCH_ORDERS_FAILURE,
  payload: { errors }
});

export const syncOrdersRequest = request => ({
  type: FETCH_ORDERS_SYNC,
  payload: request
});

const ORDERS_API = getConfig()?.orderHistoryApi;

export async function getOrders(
    dispatch:any,
    request: GetOrdersRequest,
    merge: boolean = false,
    orders: any,
    baseSiteUID:string,
    salesAreaDependantCustomerUid:string,
    currentLanguage:string
  )
{
  console.log('eve me u getOrders u actions');
  const url = `${ORDERS_API}${request.toQueryString()}`;
  dispatch(fetchOrdersBegin(request));
  return fetch(url, {
    headers: {
      'Authorization': `Bearer ${await accessToken()}`,
      'PT-Base-Site-UID': `${baseSiteUID}`,
      'PT-Sales-Area-Dependent-Customer-Uid': `${salesAreaDependantCustomerUid}`,
      'Accept-language': currentLanguage,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then(res => {
    if (!res.ok) {
      throw new ErrorResponseWrapper(res);
    } else {
      return res.json();
    }
  })
  .then(data => {
    data.orders = data.orders ?? [];
    if (merge) {
      data.orders = [...orders, ...data.orders];
    }
    dispatch(fetchOrdersSuccess(data));
    return(data);
  })
  .catch((errorResponse: ErrorResponseWrapper) => {
/*
    errorResponse.getErrorMessages().then((messages) => {
      dispatch(fetchOrdersFailure(messages));
    })
*/
    dispatch(fetchOrdersFailure(errorResponse))
  })
}

export function syncOrders(request: GetOrdersRequest) {
  return dispatch => {
    dispatch(syncOrdersRequest(request));
  }
}


/* order detail */
export const fetchOrderDetailsBegin = request => ({
  type: FETCH_ORDER_DETAILS_BEGIN,
  payload: request
});

export const fetchOrderDetailsSuccess = (orderNo, orderDetailResponse) => ({
  type: FETCH_ORDER_DETAILS_SUCCESS,
  payload: { orderNo, orderDetailResponse }
});

export const fetchOrderDetailsFailure = errors => ({
  type: FETCH_ORDER_DETAILS_FAILURE,
  payload: { errors: errors }
});

export const updateOrderDetailsState = (orderNo, data) => ({
  type: UPDATE_ORDER_DETAILS_STATE,
  payload: { orderNo, data }
});

export async function getOrderDetail(request: GetOrderDetailsRequest, dispatch:any, baseSiteUID:string, salesAreaDependantCustomerUid:string, currentLanguage: string = 'en') {
  const url = `${ORDERS_API}${request.toQueryString()}`;
  dispatch(fetchOrderDetailsBegin(request));
  return fetch(url, {
    credentials: "same-origin",
    headers: {
      'Authorization': `Bearer ${await accessToken()}`,
      'PT-Base-Site-UID': `${baseSiteUID}`,
      'PT-Sales-Area-Dependent-Customer-Uid': `${salesAreaDependantCustomerUid}`,
      'Accept-language': currentLanguage,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then(res => {
    if (!res.ok) {
      throw new ErrorResponseWrapper(res);
    }
    return res.json();
  })
  .then(data => {
    dispatch(fetchOrderDetailsSuccess(request.orderNo, data));
    return data;
  })
  .catch(async (errorResponse: ErrorResponseWrapper) => {
    dispatch(fetchOrderDetailsFailure(errorResponse))
    return {errors:true}
  });
}


export function updateOrderDetailsCollapseState(orderNo: string, isCollapsed: boolean = true) {
  return dispatch => {
    dispatch(updateOrderDetailsState(orderNo, { collapsed: isCollapsed }));
  }
}

export async function getOrderItemDetails(request: GetOrderItemDetailsRequest, dispatch:any, baseSiteUID:string, salesAreaDependantCustomerUid:string, currentLanguage:string) {
  const url = `${ORDERS_API}${request.toQueryString()}`;
  return fetch(url, {
    credentials: "same-origin",
    headers: {
      'Authorization': `Bearer ${await accessToken()}`,
      'PT-Base-Site-UID': `${baseSiteUID}`,
      'PT-Sales-Area-Dependent-Customer-Uid': `${salesAreaDependantCustomerUid}`,
      'Accept-language': currentLanguage,
      'Accept': 'application/json'
    }
  })
  .then(res => {
    if (!res.ok) {
      throw new ErrorResponseWrapper(res);
    }
    return res.json();
  });
}
